import { LOCALES } from '@marketplace/i18n';

export const technicalDetailsI18n = {
  [LOCALES.ENG]: {
    technicalDetailsForm_redirect_uri_sandbox: 'redirect uri',
    technicalDetailsForm_signInCheckbox: 'Sign-in required',
    technicalDetailsForm_smart_launch_url_sandbox: 'smart launch url',
    technicalDetailsForm_password: 'Password',
    technicalDetailsForm_notes: 'Notes',
    technicalDetailsForm_firstName: 'First Name',
    technicalDetailsForm_lastName: 'Last Name',
    technicalDetailsForm_phone: 'Phone',
    technicalDetailsForm_email: 'Email',

    technicalDetailsForm_appMainTitle: 'App',
    technicalDetailsForm_appReviewInfoTitle: 'App Review Info',
    technicalDetailsForm_contactInfoTitle:
      'Please provide contact info of a person who can be reached in case of additional questions or clarifications.',
    technicalDetailsForm_contactInfoDescriptionText:
      'Please provide username and password so we can sign in to the app and review it.',
    technicalDetailsForm_cancelButton: 'Cancel',
    technicalDetailsForm_saveButton: 'Save',

    //=================================

    technicalDetailsForm_tenant: 'Make Available to These Practice(s)',
    technicalDetailsForm_select_tenants: 'Choose needed tenants',
    technicalDetailsForm_auth_type_title: 'Authentication Type (OAuth Client Type)',
    technicalDetailsForm_auth_mechanism: 'Authentication Mechanism',
    technicalDetailsForm_client_type_public: 'Public',
    technicalDetailsForm_client_type_confidential: 'Confidential',
    technicalDetailsForm_confidential_secret_secretkey:'Secret',
    technicalDetailsForm_confidential_secret_Jwkskey:'JWKS',
    technicalDetailsForm_no_tenants: 'No tenants available',
    technicalDetailsForm_confidential_placeholder:'https://',

    technicalDetailsForm_application_type_title: 'Application Launch Type',

    technicalDetailsForm_application_type_standalone: 'Standalone',
    technicalDetailsForm_application_type_web: 'Web',
    technicalDetailsForm_application_type_mobile: 'Mobile native',
    technicalDetailsForm_application_type_desktop: 'Desktop native',
    technicalDetailsForm_application_type_ehr_embeded: 'EHR embedded',
    technicalDetailsForm_application_type_run_outside_of_patient_chart: 'runs outside of the patient chart',
    technicalDetailsForm_application_type_run_inside_patient_chart: 'runs inside a patient chart',
    technicalDetailsForm_application_type_backend: 'Back-end service',

    technicalDetailsForm_token_introspection_title: 'Token Introspection',
    technicalDetailsForm_token_introspection_offline: 'Offline',
    technicalDetailsForm_token_introspection_online: 'Online',
    technicalDetailsForm_token_introspection_offline_hint:
      'An app with "offline access" can continue to get new access tokens without the user being interactively engaged with the app. This is used for cases such as EHR launch, where a user that us already authenticated to the EHR can launch embedded SMART application without needing to authenticate a second time inside SMART app. Offline is also used when the app should have long-term access extending beyond the time when a user is still interacting with the client.',
    technicalDetailsForm_token_introspection_online_hint:
      'An app with the online access can continue to get new access tokens as long as the end-user remains online.',

    technicalDetailsForm_launch_context_title: 'Launch Context',
    technicalDetailsForm_launch_context_title_hint:
      'Launch of standalone applications that require patient and/or encounter context will include a patient/encounter selector displayed by our authorization server during the authentication process prior to app launch.',
    technicalDetailsForm_jwks_hint:
    'Enter the publicly-accessible URL of your public JWKS key',
    technicalDetailsForm_launch_context_patient: 'Patient context(launch/patient)',
    technicalDetailsForm_launch_context_encounter: 'Encounter context(launch/encounter)',

    technicalDetailsForm_scopes_title: 'Title',
    technicalDetailsForm_scopes_patient_population: 'Scopes for Patient Population',
    technicalDetailsForm_scopes_patient_individual: 'Scopes for Individual Patient',
    technicalDetailsForm_scopes_system: 'System scopes',
    technicalDetailsForm_select_all_scope_header: 'Select All Scopes (system/*.read)',
    technicalDetailsForm_select_all_scope_header_v2: 'Select All Scopes (system/*.rs)',

    technicalDetailsForm_launch_scopes_title: 'Scopes',
    technicalDetailsForm_scopes_header_read: 'Read',
    technicalDetailsForm_scopes_header_write: 'Write',
    technicalDetailsForm_scopes_header_write_hint: 'Coming soon',
    technicalDetailsForm_scopes_header_scopes: 'Scopes',

    technicalDetailsForm_sandbox_title: 'Sandbox',
    technicalDetailsForm_production_title: 'Production',

    technicalDetailsForm_smart_launch_url: 'Smart Launch URL',
    technicalDetailsForm_redirect_uri: 'Redirect URI',
    technicalDetailsForm_client_id: 'Client ID',
    technicalDetailsForm_client_secret: 'Client Secret',
    technicalDetailsForm_secret: 'Secret',
    technicalDetailsForm_identical_url:'Smart Launch URL and Redirect URL cannot be identical',

    error_scope_one_must_be_chosen: 'At least one scope must be chosen',

    technicalDetailsForm_jwks : 'JWK Key/URL',
    //echnicalDetailsForm_jwks_label : 'Value',
    technicalDetailsForm_jwks_label : 'Production JWKS Location',
    technicalDetailsForm_secret_tooltip : 'A client secret will be automatically generated when this application is published.',
    technicalDetailsForm_jwks_tooltip : 'If your application authentication type is set to Confidential, please provide JWK key or JWK URL.',
    technicalDetailsForm_secret_reset : "Reset",
    technicalDetailsForm_secret_reset_tooltip_admin : "Click to reset client secret",

    technicalDetailsForm_scope_condition_hint_description: 'Includes Encounter Diagnosis, Problem List, Health Concern, and Other Condition Resources.',
    technicalDetailsForm_scope_observation_hint_description: 'Includes Clinical Test, Laboratory, Social History, SDOH, Survey, Vital Signs, and Other Observation Resources.',
    technicalDetailsForm_scopes_title_verbiage: 'Allowed Read and Search Permissions/Scopes',

  },
};
